import Link from 'next/link'

import { Text } from '@wartek-id/text-v1'

import { navigation } from 'app/RuangGtkHomePageV2/lib/constants'
import { assetUrl } from 'utils/url'

export function Footer() {
  return (
    <footer data-testid="footer" className="bg-gray-100 text-white">
      <div className="flex mx-auto w-full md:max-w-4xl lg:max-w-5xl xl:max-w-7xl 2xl:max-w-screen-2xl flex-col gap-24 px-5 pb-20 pt-16">
        <div className="grid flex-col justify-between gap-x-32 gap-y-8 lg:flex lg:flex-row lg:gap-4">
          <div className="flex max-w-sm flex-col items-start justify-center gap-6 lg:flex-row">
            <img
              src={assetUrl('/images/kemendikbud2x.png')}
              alt=""
              width={120}
              height={120}
            />
            <div className="flex flex-col gap-2">
              <Text
                as="h3"
                variant="heading-sm"
                color="inverse"
                className="!text-base"
                aria-label="Alamat Kementerian Pendidikan Dasar dan Menengah"
              >
                Kementerian Pendidikan Dasar dan Menengah
              </Text>
              <Text color="inverse" className="!text-sm">
                Kompleks Kementerian Pendidikan dan Kebudayaan, Senayan, Jakarta
                Pusat 10270
              </Text>
            </div>
          </div>

          <nav
            className="flex flex-col gap-3"
            aria-labelledby="footer-navigation"
          >
            <Text
              as="h3"
              variant="heading-md"
              color="inverse"
              id="footer-navigation"
              aria-label="Daftar navigasi di Rumah Pendidikan"
            >
              Navigasi
            </Text>
            <ul className="grid gap-2">
              {navigation.map((object) => (
                <li key={object.id}>
                  <Link
                    href={object.url}
                    passHref
                    {...('target' in object && { target: object.target })}
                    {...('rel' in object && { rel: object.rel })}
                  >
                    <Text as="a" color="inverse">
                      {object.name}
                    </Text>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <section
            className="flex max-w-96 flex-grow flex-col gap-5"
            aria-labelledby="mobile-apps"
          >
            <h3 id="mobile-apps" className="text-lg font-semibold">
              Unduh Aplikasi Rumah Pendidikan
            </h3>
            <div
              className="flex gap-3"
              role="group"
              aria-label="Tautan unduh aplikasi mobile"
            >
              <Link
                passHref
                href="https://play.google.com/store/apps/details?id=com.kemendikdasmen.rumahpendidikan"
              >
                <a aria-label="Unduh via Google Play Store">
                  <img
                    src={assetUrl('/images/google-play.png')}
                    alt=""
                    width={156}
                    height={49}
                    loading="lazy"
                  />
                </a>
              </Link>
              <Link
                passHref
                href="https://apps.apple.com/id/app/rumah-pendidikan/id6741482400"
              >
                <a aria-label="Unduh via App Store">
                  <img
                    src={assetUrl('/images/app-store.png')}
                    alt=""
                    width={156}
                    height={49}
                    loading="lazy"
                  />
                </a>
              </Link>
            </div>
          </section>
        </div>
      </div>
    </footer>
  )
}
